import { defineComponent as _defineComponent } from 'vue'
import type { PlotRecommenderTitleFragment } from './GetPlotRecommenderTitles.query';
import type { YoutubePlayerOptions } from '@/interfaces/components/youtube-player';
import type { TrailerClipsFragment } from '@/pages/graphql/fragments/TrailerClips.fragment';

import { ref } from 'vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import YoutubePlayer from '@/ui-components/YoutubePlayer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderTrailerModal',
  props: {
    clip: null,
    title: null,
    source: null
  },
  setup(__props: any) {

const props = __props as {
	clip: TrailerClipsFragment;
	title: PlotRecommenderTitleFragment;
	source: string;
};



const isActive = ref(false);

const trackingMap: Record<string, string> = {
	buffering: 'youtube_buffering',
	playing: 'youtube_playing',
	paused: 'youtube_paused',
};

const playerVars: YoutubePlayerOptions = {
	autohide: 1,
	autoplay: 1,
	iv_load_policy: 3,
	modestbranding: 1,
	rel: 0,
};

function onTrack(eventName: string) {
	const category = trackingMap[eventName];
	if (category == null) return;

	TrackingHelper.trackEvent(category, { action: props.title.objectType, label: props.source }, [
		SnowplowTitleContextGraphql.fromTitle(props.title),
	]);
}

function onActivate(clipId: string | null) {
	isActive.value = clipId === props.clip.externalId;
}

return { __sfc: true,props, isActive, trackingMap, playerVars, onTrack, onActivate, BaseModal, YoutubePlayer }
}

})